function TableSelectAdapter(data: any) {
    if (data) {
        return {
            cabecerasCol: data.content[0].content[0].content.map((cabecera: any) => ({
                cabeceraName: cabecera.content[0].content[0].value,
            })),
            filas: data.content[0].content.slice(1).map((filaAux: any) => ({
                fila: filaAux.content.map((filaAux2: any) => ({
                    col: filaAux2.content[0].content[0].value,
                })),
            })),
        };
    }
    return { cabecerasCol: [], filas: [] }; // Retorno vacío si data es null o undefined
}

export default TableSelectAdapter
